
import Article from "./Article"
import AppButton from "./AppButton"
import ContentBlockList from "./ContentBlockList"
import stubDirectives from "../mixins/stubDirectives"
import carousel from "../mixins/carousel"

export default {
  components: {
    Article,
    AppButton,
    ContentBlockList
  },
  mixins: [stubDirectives, carousel],
  inheritAttrs: false,
  props: {
    heading: {
      type: String,
      default: null
    },
    copy: {
      type: Object,
      required: true
    },
    image: {
      type: Object,
      default: null
    },
    sideImage: {
      type: Array,
      default: null
    },
    button: {
      type: Array,
      default: null
    },
    cards: {
      type: Array,
      required: true
    },
    backgroundColor: {
      type: String,
      default: null
    },
    fontColor: {
      type: String,
      default: null
    },
    descriptiveLabel: {
      type: String,
      default: null
    },
    buttonsMobile: {
      type: Boolean,
      default: false
    },
    margins: {
      type: String,
      default: null,
      validator: val => ["small", "large"].includes(val)
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    leftArrowButtonTracking: {
      type: Array,
      default: null
    },
    rightArrowButtonTracking: {
      type: Array,
      default: null
    },
    smallHeading: {
      type: String,
      default: null
    },
    backgroundImage: {
      type: Object,
      default: null
    },
    leftTitle: {
      type: Boolean,
      default: false
    },
    rewind: {
      type: Boolean,
      default: false
    },
    sectionId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      carouselClassNames: {
        slide: "carousel__slide",
        slides: "carousel__slides",
        wrapper: "carousel__wrapper"
      }
    }
  },
  computed: {
    imageObject() {
      if (this.sideImage && this.sideImage.length) {
        return this.sideImage[0]
      }
      if (this.image) {
        return { image: this.image }
      }
      return null
    },
    buttonProps() {
      const buttonBlock = this.button && this.button[0]
      if (buttonBlock) {
        const { _uid, component, ...props } = buttonBlock
        return props
      }
      return null
    },
    nextPrevButtonClasses() {
      return {
        "carousel-bottom__arrow--mobile-buttons": this.buttonsMobile
      }
    },
    carouselClasses() {
      return {
        "carousel__margin-small": this.margins === "small",
        "no-padding": this.noPadding
      }
    },
    carouselBottomClasses() {
      return {
        "carousel-bottom__margin-small": this.margins === "small",
        "carousel-bottom__buttons-right": !this.buttonProps,
        "no-padding": this.noPadding
      }
    },
    containerStyle() {
      const style = {}

      if (this.fontColor) {
        style.color = this.fontColor
      }
      if (this.backgroundColor) {
        style.backgroundColor = this.backgroundColor
      }
      if (this.backgroundImage) {
        style.backgroundImage = `url(${this.backgroundImage.filename})`
      }
      return style
    }
  },
  mounted() {
    this.whenReadyInitiateCarousel(this.carouselClassNames)
  }
}
